import { Share } from 'react-native';

import {
  eventDetailsUrl,
  eventShareMessage,
  routeShareUrl,
  tenantProfileUrl,
} from '@/lib/share-content';

export async function shareTenantProfile({
  tenantName,
  tenantSlug,
}: Readonly<{
  tenantName?: string | null;
  tenantSlug: string;
}>) {
  const url = tenantProfileUrl(tenantSlug);
  const title = tenantName?.trim() || '6am BKK';

  await Share.share({
    message: `${title}\n${url}`,
    title,
    url,
  });
}

export async function shareEventDetails({
  eventId,
  eventTitle,
  eventWhen,
  placeName,
  tenantName,
  tenantSlug,
}: Readonly<{
  eventId: string;
  eventTitle: string;
  eventWhen?: string;
  placeName?: string | null;
  tenantName?: string | null;
  tenantSlug: string;
}>) {
  const url = eventDetailsUrl(tenantSlug, eventId);
  const title = eventTitle.trim() || '6am event';

  await Share.share({
    message: eventShareMessage({
      eventTitle: title,
      eventWhen,
      placeName,
      tenantName,
      url,
    }),
    title,
    url,
  });
}

export async function shareEventInvite({
  eventId,
  eventTitle,
  eventWhen,
  placeName,
  tenantName,
  tenantSlug,
}: Parameters<typeof shareEventDetails>[0]) {
  const url = eventDetailsUrl(tenantSlug, eventId);
  const title = eventTitle.trim() || '6am event';
  const details = eventShareMessage({
    eventTitle: title,
    eventWhen,
    placeName,
    tenantName,
    url,
  });

  await Share.share({
    message: `I’m going — come run with me.\n${details}`,
    title,
    url,
  });
}

export async function shareRoute({
  name,
  shareToken,
}: Readonly<{ name: string; shareToken: string }>) {
  const url = routeShareUrl(shareToken);
  const title = name.trim() || '6am route';
  await Share.share({ message: `${title}\n${url}`, title, url });
}
